import styled from '@emotion/styled';
import { Dialog } from '@lightspeed/flame/Dialog';
import { Label as BaseLabel } from '@lightspeed/flame/FormField';
import { Modal } from '@lightspeed/flame/Modal';

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 18px;
  margin-bottom: 8px;
`;

const DuplicateDialog = styled(Dialog)`
  max-width: 587px;
`;

const MatrixDialog = styled(Modal)`
  max-width: 994px;
  width: 994px;
`;

const Label = styled(BaseLabel)`
  margin-top: 16px;
  line-height: 18px;
`;

const ImageDisplay = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  max-width: 100px;
  max-height: 100px;
  > img {
    border-radius: 2px;
    max-width: 100px;
    max-height: 100px;
  }
`;

const ImageCount = styled.div`
  position: absolute;
  bottom: 0;
  background: #f2f5f8;
  text-align: center;
  width: 100px;
  font-size: 14px;
`;

export { ValuesGrid, DuplicateDialog, MatrixDialog, Label, ImageDisplay, ImageCount };
